// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as failoverDomainActions from 'common/modules/failoverDomain/actions';
import {
    ActionType,
    getType,
} from 'typesafe-actions';
import {
    IPaginateApiResponse,
    paginateInitialState,
} from 'common/api/resources/Response';
import { IFailoverDomainResponse } from 'common/api/resources/FailoverDomain';

export type FailoverDomainAction = ActionType<typeof failoverDomainActions>;
export type FailoverDomainState = IPaginateApiResponse<IFailoverDomainResponse[]>;

const updateListItem = (
    state: IPaginateApiResponse<IFailoverDomainResponse[]>,
    id: number,
    patch: Partial<IFailoverDomainResponse>
): IPaginateApiResponse<IFailoverDomainResponse[]> => ({
    ...state,
    data: state.data.map(item => item.id === id ? { ...item, ...patch } : item),
});

export default (
    state: FailoverDomainState = paginateInitialState,
    action: FailoverDomainAction
): FailoverDomainState => {
    switch (action.type) {
    case getType(failoverDomainActions.setFailoverDomainList):
        return action.payload;
    case getType(failoverDomainActions.updateFailoverDomainItem):
        return updateListItem(state, action.payload.id, action.payload);
    case getType(failoverDomainActions.setFailoverDomainItemIsLoading):
        return updateListItem(state, action.payload, { is_loading: true });
    case getType(failoverDomainActions.unsetFailoverDomainItemIsLoading):
        return updateListItem(state, action.payload, { is_loading: false });
    case getType(failoverDomainActions.removeFailoverDomainItem):
        return {
            ...state,
            data: state.data.filter(item => item.id !== action.payload),
        };
    default:
        return state;
    }
};
